import { FC, useEffect, useState } from 'react';

import { useSelector } from 'react-redux';

import { Outlet, useNavigate } from 'react-router-dom';

import { RootState } from 'store/index';
import { useGetProgressQuery } from 'store/progress';

// オンボーディングが完了しているかどうかを判定する
export const OnBoardingGuard: FC = () => {
  const navigate = useNavigate();
  const { data, isLoading, isError, error, refetch } = useGetProgressQuery();
  const [retryCount, setRetryCount] = useState(0);
  const requestedDirectory = useSelector((state: RootState) => state.progress.requestedDirectory);
  const [runRedirect, setRunRedirect] = useState<boolean>(true);

  useEffect(() => {
    // オンボーディングが完了していない場合はチュートリアルページに遷移する
    if (!isLoading && !data?.isOnboardingCompleted) {
      navigate('/tutorial?phase=story');
    }
  }, [navigate, data, isLoading]);

  useEffect(() => {
    if (!isLoading && isError && retryCount < 5) {
      setRetryCount((count: number) => count + 1);
      console.log(`OnBoardingGuard error: リトライ開始`);
      setTimeout(refetch, 1000);
    }
  }, [isLoading, isError, retryCount, refetch]);

  useEffect(() => {
    if (!isLoading && data?.isOnboardingCompleted && requestedDirectory !== '/' && runRedirect) {
      setRunRedirect(false);
      console.log(`OnBoardingGuard: ${requestedDirectory} へ移動`);
      navigate(requestedDirectory);
    }
  }, [isLoading, data, requestedDirectory, runRedirect, navigate]);

  if (isError && retryCount >= 5) {
    console.log('OnBoardingGuard error', error);
    return <></>;
  }
  if (isLoading) return <></>;

  return <Outlet />;
};
